/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useReducer, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import produce from "immer";
import ButtonIcon from "../../../shared/controls/ButtonIcon";
import alerts from "../../../shared/alerts";
import FieldAutoComplete from "../../../shared/controls/fieldAutoComplete";
import FieldDropDown from "../../../shared/controls/fieldDropDown";
import FieldTextArea from "../../../shared/controls/fieldTextArea";
import FieldCalendar from "../../../shared/controls/fieldCalendar";
import FieldTextBox from "../../../shared/controls/fieldTextBox";
import constantes from "../../constantes";
import { default as constantesCatalogos } from "../../../catalogos/constantes";
import FieldInputNumber from "../../../shared/controls/fieldInputNumber";
import { Button } from "primereact/button";
import UseApiOrdenServicio from "../../../api/taller/useApiOrdenServicio";
import { RadioButton } from "primereact/radiobutton";
import OrdenTrabajoValidacionEsquema from "./ordenTrabajoValidacionEsquema";
import formReducer from "../../../shared/forms/formReducer";
import FormHandler from "../../../shared/forms/formHandler";
import CheckList from "./checklist";
import { Dialog } from "primereact/dialog";
import YupValidator from "../../../shared/YupValidator";
import printJS from "print-js";
import moment from "moment";
import { useReactToPrint } from "react-to-print";
import CancelacionOrdenTrabajo from "./cancelacionOrdenTrabajo";
import ComponentToPrint from "../../pdfComponentes/checklistpdf";
import useSeguridad from "../../../Seguridad/useSeguridad";
import { useEmpresa } from "../../../layout/EmpresaProvider";
import LogOrdenTrabajo from "./logOrdenTrabajo";
import FieldCheckBox from "../../../shared/controls/fieldCheckBox";
import { useAuth } from "../../../Seguridad/AuthProvider";
import "./detalleOrdenTrabajo.css";
import RequisicionDetalle from "../../requisiciones/requisicionDetalle";

import InputFile from "../../../shared/controls/inputFile";
import DetalleSolicitudServicio from "../solicitudservicio/detalleSolicitudServicio";

const DetalleOrdenTrabajo = (servicios) => {
  const seguridad = useSeguridad();
  const soloLectura = !seguridad.esEditable(
    constantesCatalogos.menus.mantenimiento,
  );
  const [errorsReprogramacion, setErrorsReprogramacion] = useState({});
  const [copyOrdenTrabajo, setCopyOrdenTrabajo] = useState({});
  const [checkListVisible, setCheckListVisible] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [modalOtroTallerVisible, setModalOtroTallerVisible] = useState(false);

  const [indiceTallerOtro, setIndiceTallerOtro] = useState(null);

  const [nombreTallerTemporal, setNombreTallerTemporal] = useState("");
  const [unidadInformacion, setUnidad] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [mostrarInfo, setMostrarInfo] = useState(false);
  const [modoSoloVerSolicitud, setModoSoloVerSolicitud] = useState(false);

  const apiOrdenServicio = UseApiOrdenServicio();
  const history = useNavigate();
  const [ordenTrabajoId, setOrdenTrabajoId] = useState(0);
  const [errorServicios, setErrorServicios] = useState(false);
  const [, setNombreSolicitante] = useState("");
  const [visibleModalCancelacion, setVisibleModalCancelacion] = useState(false);
  const [fallas, setFallas] = useState(5);
  const [mostrarSolicitudServicio, setMostrarSolicitudServicio] =
    useState(false);
  const [solicitudServicioId, setSolicitudServicioId] = useState(0);
  const [requisicionId, setrequisicionId] = useState(0);
  const [mostrarRequisicion, setMostrarRequisicion] = useState(false);

  // const [mostrarSolicitudServicio,setmostrarSolicitudServicio] = useState(false)
  // const [,setSolictudServicio] = useState(0);
  const { user: usuario } = useAuth();
  let { id } = useParams();
  id = parseInt(id);

  const [guardarCheckList, setguardarCheckList] = useState(false);
  const [mostrarAreaCheckList, setMostrarAreaCheckList] = useState(false);
  const { disable: disableEmpresa } = useEmpresa();
  let permisoReabriOrden = seguridad.tieneAcceso(
    constantesCatalogos.opciones.permisoReabrirOrden,
  );

  const abrirDetalleSolicitud = (idSolicitud) => {
    setModoSoloVerSolicitud(true);
    setSolicitudServicioId(idSolicitud);
    setMostrarSolicitudServicio(true);
  };
  const abrirDetalleRequisiciones = (idRequisicion) => {
    setMostrarRequisicion(true);
    setrequisicionId(idRequisicion);
  };
  const agregarRequisicion = () => {
    setMostrarRequisicion(true);
    setrequisicionId(0);
  };
  const cerrarDetalleSolicitud = () => {
    setModoSoloVerSolicitud(false);
    setMostrarSolicitudServicio(false);
    setSolicitudServicioId(0);
  };

  const onSaveSolicitud = async () => {
    cerrarDetalleSolicitud();
    await cargarOrden();
  };
  const solicitante = usuario.nombre;
  const validador = new YupValidator(OrdenTrabajoValidacionEsquema.guardar);
  const validadorReprogramar = new YupValidator(
    OrdenTrabajoValidacionEsquema.reprogramar,
  );

  const validadorFinalizar = new YupValidator(
    OrdenTrabajoValidacionEsquema.finalizar,
  );

  const defaultSolicitudServicio = () => ({
    entity: {
      paradas: [],
      servicios: [],
      refacciones: [],
      id: 0,
      operador: null,
      nombreSolicitante: solicitante,
      nombreOperador: "",
      jefeInmediatoNombre: "",
      unidadNombre: "",
      unidadDeNegocio: "",
      mecanicos: [],
      tallerExterno: [],
      esExterno: false,
      responsableRescate: null,
      empresaId: 0,
      diagnostico: [],
      costoGeneral: null,
    },
  });

  const [{ entity, errors, ...state }, dispatch] = useReducer(
    formReducer,
    null,
    defaultSolicitudServicio,
  );
  const esMantenimientoPreventivo =
  (entity.tipoServicio?.nombre ?? "").trim().toUpperCase() ===
  "MANTENIMIENTO PREVENTIVO";
  const esRescate =
    (entity.tipoServicio?.nombre ?? "").trim().toUpperCase() ===
    "MANTENIMIENTO RESCATE";
  useEffect(() => {
    if (mostrarSolicitudServicio) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [mostrarSolicitudServicio]);

  useEffect(() => {
    if (state.submitted === true) {
      formHandler.setValidacionSchema(OrdenTrabajoValidacionEsquema.guardar);
      formHandler.validate(entity);
    }
    mostrarCheckList();
  }, [entity]);

  useEffect(() => {
    cargarOrden();
    disableEmpresa();
  }, []);
  async function cargarOrden() {
    if (id === 0) {
      dispatch({ type: "reset", getDefault: () => defaultSolicitudServicio() });
      let solicitante = entity.nombreSolicitante
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      setNombreSolicitante(solicitante);
      return;
    }

    const entityApi = await apiOrdenServicio.obtener(id);
    entityApi.servicios = (entityApi.servicios ?? []).map((servicio) => ({
      ...servicio,
      rowId: servicio.rowId ?? crypto.randomUUID(),
    }));

    dispatch({ type: "reset", getDefault: () => ({ entity: entityApi }) });

    const nombreOperador =
      entityApi?.nombreOperador ?? entityApi?.NombreOperador ?? "";

    if (nombreOperador && !entityApi?.operador && !entityApi?.Operador) {
      dispatch({
        type: "update",
        name: "operador",
        value: { id: 0, nombre: nombreOperador },
      });
    }

    dispatch({
      type: "update",
      name: "jefeInmediatoNombre",
      value:
        entityApi?.jefeInmediatoNombre ?? entityApi?.JefeInmediatoNombre ?? "",
    });

    dispatch({
      type: "update",
      name: "unidadDeNegocio",
      value: entityApi?.unidadDeNegocio ?? entityApi?.UnidadDeNegocio ?? "",
    });

    setCopyOrdenTrabajo({ entity: entityApi });
    dispatch({ type: "update", value: id, name: "id" });
    setOrdenTrabajoId(id);
    setUnidad(entityApi?.datosUnidad);

    let solicitante = (entityApi?.nombreSolicitante ?? "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    setNombreSolicitante(solicitante);

    setMostrarInfo(true);
    if (entityApi?.fallas?.length > 1) setFallas(entityApi.fallas.length * 2);
  }

  async function actualizar(value, propertyName) {
    dispatch({ type: "update", value, name: propertyName });
    if (
      propertyName === "tipoServicio" &&
      (value?.nombre ?? "").trim().toUpperCase() !== "MANTENIMIENTO RESCATE"
    ) {
      dispatch({
        type: "update",
        name: "responsableRescate",
        value: null,
      });
    }
    if (propertyName === "tipoServicio") setMostrarInfo(true);
    if (propertyName === "unidad") await obtenerInformacionUnidad(value);
    if (propertyName === "mantenimiento")
      await obtenerInformacionActividades(value);
    if (propertyName === "unidad") {
      await obtenerSolicitudServicio(value);

      dispatch({
        type: "update",
        name: "unidadDeNegocio",
        value: value?.unidadDeNegocio?.nombre ?? "",
      });
    }

    if (propertyName === "operador") {
      if (!value?.id) {
        dispatch({ type: "update", name: "nombreOperador", value: "" });
        dispatch({ type: "update", name: "jefeInmediatoNombre", value: "" });
        dispatch({ type: "update", name: "unidadDeNegocio", value: "" });
        return;
      }

      dispatch({
        type: "update",
        name: "nombreOperador",
        value: value.nombre ?? "",
      });
      dispatch({
        type: "update",
        name: "unidadDeNegocio",
        value: value.unidadNegocioNombre ?? "",
      });

      await obtenerInfoOperador(value);
    }
  }
  async function obtenerInfoOperador(operador) {
    try {
      const info = await apiOrdenServicio.obtenerInfoOperador(operador.id);

      dispatch({
        type: "update",
        name: "jefeInmediatoNombre",
        value: info?.jefeInmediato?.nombre ?? "",
      });
    } catch (err) {
      console.error("Error obtenerInfoOperador:", err);
    }
  }

  function actualizarSeleccion(indexSeleccionado, valueSeleccionado) {
    const nuevos = entity.solicitudesServicio.map((x, i) =>
      i === indexSeleccionado ? { ...x, seleccionado: valueSeleccionado } : x,
    );
    dispatch({ type: "update", name: "solicitudesServicio", value: nuevos });
  }
  async function back() {
    history("/taller/mantenimiento");
  }

  const formHandler = new FormHandler({
    validationSchema: OrdenTrabajoValidacionEsquema.guardar,
    api: apiOrdenServicio,
    dispatch,
  });
  const guardar = async (callValidation, esEntradaTaller) => {
    let evidenciaToSend = undefined;
    if (entity.evidencia && !entity.evidencia.isEmpty) {
      const { file, ...resto } = entity.evidencia;
      evidenciaToSend = resto;
    }
    const entityToSave = {
      ...entity,
      ...(evidenciaToSend !== undefined ? { evidencia: evidenciaToSend } : {}),
      nombreOperador: entity.nombreOperador ?? "",
      jefeInmediatoNombre: entity.jefeInmediatoNombre ?? "",
      unidadDeNegocio: entity.unidadDeNegocio ?? "",
      empresaId: entity.empresaId.id,

      fechaEntrada: entity.fechaEntrada
        ? moment(entity.fechaEntrada).format("YYYY-MM-DD HH:mm:00")
        : null,
      fechaSalida: entity.fechaSalida
        ? moment(entity.fechaSalida).format("YYYY-MM-DD HH:mm:00")
        : null,
      fechaEnTaller: entity.fechaEnTaller
        ? moment(entity.fechaEnTaller).format("YYYY-MM-DD HH:mm:00")
        : null,
      fechaCompromiso: entity.fechaCompromiso
        ? moment(entity.fechaCompromiso).format("YYYY-MM-DD HH:mm:00")
        : null,
      esEntradaTaller: esEntradaTaller ?? false,
    };

    if (entityToSave.servicios.length === 0) setErrorServicios(true);

    if ((await validador.validate(entityToSave)) === false) {
      await formHandler.save(entityToSave, true);
      return;
    }

    if (entityToSave.servicios.length === 0) {
      return;
    }

    let esReprogramacion = false;
    // if (
    //   constantes.estatusOrdenesTrabajo.reprogramada === entityToSave.estatus ||
    //   constantes.estatusOrdenesTrabajo.programada === entityToSave.estatus ||
    //   constantes.estatusOrdenesTrabajo.EnTaller === entityToSave.estatus
    // )
    if (
      copyOrdenTrabajo.fechaEntrada !== entityToSave.fechaEntrada ||
      copyOrdenTrabajo.fechaSalida !== entityToSave.fechaSalida ||
      copyOrdenTrabajo.fechaEntaller !== entityToSave.fechaEnTaller ||
      copyOrdenTrabajo.fechaCompromiso !== entityToSave.fechaCompromiso ||
      // copyOrdenTrabajo.mecanico?.id !== entityToSave.mecanico?.id ||
      copyOrdenTrabajo.tallerExterno?.id !== entityToSave.tallerExterno?.id
    ) {
      esReprogramacion = await apiOrdenServicio.esReprogramacion(
        entityToSave.id,
        {
          fechaEntrada: entityToSave.fechaEntrada,
          fechaSalida: entityToSave.fechaSalida,
        },
      );
    }
    if (esReprogramacion) setVisibleModal(true);
    else {
      const ordenTrabajoGuardada = await formHandler.save(entityToSave, true);

      if (id !== 0) {
        let ordenTrabajo = { entity: await apiOrdenServicio.obtener(id) };

        dispatch({ type: "reset", getDefault: () => ordenTrabajo });
      }
      if (entity.evidencia?.file != null) {
        await subirFormato(entity.id, entity);
      }

      if (formHandler.valdation.result === true || callValidation === false) {
        dispatch({
          type: "update",
          value: ordenTrabajoGuardada.id,
          name: "id",
        });
        history(
          "/taller/mantenimiento/editar_orden/" + ordenTrabajoGuardada.id,
        );
      }
    }

    return entityToSave;
  };
  async function subirFormato(id, entity) {
    const MAX_FILE_SIZE = 10 * 1024 * 1024;
    if (entity?.evidencia?.file !== undefined) {
      const fileSize = entity?.evidencia?.file?.size;
      if (fileSize > MAX_FILE_SIZE) {
        alerts.informacion(
          "El archivo es demasiado grande. Por favor, selecciona uno menor a 10 MB.",
        );
        return;
      }
      if (entity?.evidencia?.file.size > 0) {
        const formData = new FormData();
        formData.append("Files", entity.evidencia?.file);
        formData.append("Nombre", entity.evidencia?.file.name);
        formData.append(
          "Extension",
          entity?.evidencia?.file.name.split(".").pop(),
        );

        await apiOrdenServicio.subirFormato(id, formData);
        let ordenTrabajo = { entity: await apiOrdenServicio.obtener(id) };
        dispatch({ type: "reset", getDefault: () => ordenTrabajo });
      }
    }
  }
  const reabrir = async () => {
    await apiOrdenServicio.reabrir(ordenTrabajoId);
  };
const terminar = async (callValidation, esEntradaTaller) => {
  const entityToValidate = {
    ...entity,
    odometro: entity.esMotriz ? entity.odometro : 0,
  };

  if ((await validadorFinalizar.validate(entityToValidate)) === false) {
    dispatch({
      type: "validate",
      errors: validadorFinalizar.errors,
    });
    return;
  }

  const entityToSave = {
    ...entityToValidate,
    fechaEntrada: moment(entityToValidate.fechaEntrada).format(
      "YYYY-MM-DD HH:mm:00",
    ),
    fechaSalida: moment(entityToValidate.fechaSalida).format(
      "YYYY-MM-DD HH:mm:00",
    ),
    fechaEnTaller: moment(entityToValidate.fechaEnTaller).format(
      "YYYY-MM-DD HH:mm:00",
    ),
    fechaCompromiso: moment(entityToValidate.fechaCompromiso).format(
      "YYYY-MM-DD HH:mm:00",
    ),
    esEntradaTaller: esEntradaTaller ?? false,
  };

  await formHandler.save(entityToSave, true);

  if (id !== 0) {
    await apiOrdenServicio.terminarOrden(id, entityToSave);
  }

  await back();
  return entityToSave;
};

  async function obtenerInformacionUnidad(unidad) {
    if (unidad?.id === undefined) return;

    const unidadInformacion = await apiOrdenServicio.obtenerUnidad(unidad?.id);
    setUnidad(unidadInformacion);
  }
  async function obtenerSolicitudServicio(valor) {
    const solicitud = await apiOrdenServicio.obtenerSolicitudServicio(valor.id);

    dispatch({ type: "update", value: solicitud, name: "solicitudesServicio" });
  }
  async function obtenerInformacionActividades(mantenimiento) {
    if (mantenimiento?.id === undefined) return;

    const info = await apiOrdenServicio.obtenerServicios(mantenimiento?.id);

    dispatch({ type: "update", value: info.servicios, name: "servicios" });
    dispatch({ type: "update", value: info.refacciones, name: "refacciones" });
  }

  async function obtenerInformacionRefacciones(servicio) {
    if (servicio?.id === undefined) return;

    const info = await apiOrdenServicio.obtenerRefacciones(servicio?.id);

    info.forEach((element) => {
      const nuevo = produce(entity.refacciones, (draft) => {
        draft.splice(0, 0, element);
      });

      dispatch({ type: "update", value: nuevo, name: "refacciones" });
    });
  }

  function actualizarElementosenLista(lista, index, value, namelist) {
    if (namelist === "servicios") {
      const nuevo = produce(lista, (draft) => {
        draft[index]["actividadServicio"] = {};
        draft[index]["descripcion"] = "";
        draft[index]["existente"] = value;
      });

      dispatch({ type: "update", value: nuevo, name: namelist });
    }

    if (namelist === "refacciones") {
      const nuevo = produce(lista, (draft) => {
        draft[index]["refaccion"] = {};
        draft[index]["nombre"] = "";
        draft[index]["unidadDeMedida"] = {};
        draft[index]["cantidad"] = "";
        draft[index]["existente"] = value;
      });

      dispatch({ type: "update", value: nuevo, name: namelist });
    }
  }

  function actualizarLista(lista, index, value, propertyName, namelist) {
    const nuevo = produce(lista, (draft) => {
      draft[index][propertyName] = value;
    });

    dispatch({ type: "update", value: nuevo, name: namelist });

    if (propertyName === "actividadServicio") {
      obtenerInformacionRefacciones(value);
    }

    if (propertyName === "existente") {
      actualizarElementosenLista(lista, index, value, namelist);
    }
  }

  function crearServicioNuevo() {
    return {
      rowId: crypto.randomUUID(),
      existente: true,
      actividadServicio: null,
      descripcion: "",
      mecanico: null,
      mecanicoId: null,
    };
  }

  function agregarALista(lista = [], namelist) {
    const nuevo = produce(lista ?? [], (draft) => {
      if (namelist === "servicios") {
        draft.splice(0, 0, crearServicioNuevo());
      } else {
        draft.splice(0, 0, { rowId: crypto.randomUUID() });
      }
    });

    if (namelist === "servicios") setErrorServicios(false);

    dispatch({ type: "update", value: nuevo, name: namelist });
  }

  function eliminarDeLista(lista, index, namelist) {
    const nuevo = produce(lista, (draft) => {
      draft.splice(index, 1);
    });

    dispatch({ type: "update", value: nuevo, name: namelist });
  }

  const guardarReprogramacion = async (callValidation) => {
    setSubmitted(true);

    if ((await validadorReprogramar.validate(entity)) === false) {
      setErrorsReprogramacion(validadorReprogramar.errors);
      return;
    }
    const ordenTrabajoGuardada = await formHandler.save(entity, true);

    if (formHandler.valdation.result === true || callValidation === false) {
      dispatch({
        type: "update",
        value: ordenTrabajoGuardada.id,
        name: "id",
      });
      history("/taller/mantenimiento/editar_orden/" + ordenTrabajoGuardada.id);
    }

    setSubmitted(false);
    setVisibleModal(false);
  };

  async function cancelarOrdenTrabajo() {
    setVisibleModalCancelacion(false);
  }

  async function openModalCancelar() {
    setVisibleModalCancelacion(true);
  }

  async function obtenerCheckList() {
    if (!entity.esMotriz) await actualizar(0, "odometro");

    const newEntity = produce(entity, (draft) => {
      draft["odometro"] = entity.esMotriz ? draft["odometro"] : 0;
    });

    if ((await validadorFinalizar.validate(newEntity)) === false) {
      let errors = validadorFinalizar.errors;
      dispatch({ type: "validate", errors });
      return;
    }

    setCheckListVisible(true);
    setMostrarInfo(false);
  }
  const empleado = usuario;

  const onSaveRequisicion = async () => {
    setMostrarRequisicion(false);
    await cargarOrden();
  };

  async function guardarCheck() {
    setguardarCheckList(true);
  }

  async function cancelarGuardado() {
    setguardarCheckList(false);
  }

  const componentRef = useRef();

  const PrintPdf = useReactToPrint({
    content: () => componentRef.current,
  });
  const update = (value, name) => dispatch({ type: "update", value, name });
  const esTallerOtros = (taller) =>
    (taller?.nombre ?? "").trim().toUpperCase() === "OTROS";
  const actualizarMecanicoservicios = (value, campo, index) => {
    const mecanicoId =
      Number(value?.id ?? value?.empleadoId ?? value ?? 0) || 0;

    const nuevosServicios = (entity.servicios ?? []).map(
      (servicio, posicion) => {
        if (!esMantenimientoPreventivo && posicion !== index) {
          return servicio;
        }

        return {
          ...servicio,
          mecanico: value,
          mecanicoId,
        };
      }
    );

    update(nuevosServicios, "servicios");
  };

  const agregarExterno = () => {
    const newValue = produce(entity.tallerExterno ?? [], (draft) => {
      draft.push({
        id: 0,
        nombre: "",
        nombreProveedorOtro: "",
      });
    });

    update(newValue, "tallerExterno");
  };

  const actualizarExterno = (value, campo, index) => {
    const nombreProveedorAnterior =
      entity.tallerExterno?.[index]?.nombreProveedorOtro ?? "";

    const newValue = produce(entity.tallerExterno ?? [], (draft) => {
      draft[index] = {
        ...(value ?? {}),
        nombreProveedorOtro: esTallerOtros(value)
          ? nombreProveedorAnterior
          : "",
      };
    });

    update(newValue, "tallerExterno");

    if (esTallerOtros(value)) {
      setIndiceTallerOtro(index);
      setNombreTallerTemporal(nombreProveedorAnterior);
      setModalOtroTallerVisible(true);
    }
  };
  const abrirModalOtroTaller = (index) => {
    setIndiceTallerOtro(index);

    setNombreTallerTemporal(
      entity.tallerExterno?.[index]?.nombreProveedorOtro ?? "",
    );

    setModalOtroTallerVisible(true);
  };

  const cerrarModalOtroTaller = () => {
    setModalOtroTallerVisible(false);
    setIndiceTallerOtro(null);
    setNombreTallerTemporal("");
  };

  const guardarNombreOtroTaller = () => {
    const nombre = nombreTallerTemporal.trim();

    if (!nombre) {
      alerts.informacion("Es necesario capturar el nombre del proveedor.");
      return;
    }

    const newValue = produce(entity.tallerExterno ?? [], (draft) => {
      if (indiceTallerOtro !== null && draft[indiceTallerOtro]) {
        draft[indiceTallerOtro].nombreProveedorOtro = nombre;
      }
    });

    update(newValue, "tallerExterno");
    cerrarModalOtroTaller();
  };

  const eliminarExterno = (index) => {
    const newValue = produce(entity.tallerExterno, (draft) => {
      draft.splice(index, 1);
    });

    update(newValue, "tallerExterno");
  };
  const mostrarCheckList = async () => {
    setMostrarAreaCheckList(false);
    if (
      (entity.tipoServicio?.id ===
        constantes.tiposServicio.MantenimientoCorrectivo &&
        entity.unidad?.tipoUnidadId !== constantes.tiposUnidad.Utilitario &&
        entity.unidad?.tipoUnidadId !== constantes.tiposUnidad.Pipa) ||
      (entity.tipoServicio?.id ===
        constantes.tiposServicio.MantenimientoPreventivo &&
        entity.unidad?.tipoUnidadId !== constantes.tiposUnidad.Utilitario)
    ) {
      setMostrarAreaCheckList(true);
    }
  };

  const confirmarOrden = async () => {
    if (
      (await alerts.preguntarSiNoAdvertencia(
        "¿Desea confirmar la orden de trabajo?",
      )) === true
    ) {
      await apiOrdenServicio.confirmar(entity.id, []);
      history("/taller/mantenimiento");
    }
  };

  const entradaTaller = async () => {
    await guardar(true, true);
  };
  // const onSaveSolicitud = async () => {
  //     setSolictudServicio(0)
  //     setmostrarSolicitudServicio(false)
  //     await cargarOrden()
  // }

  return (
    <>
      <CancelacionOrdenTrabajo
        ordenTrabajoId={id}
        setVisible={cancelarOrdenTrabajo}
        esVisibleModal={visibleModalCancelacion}
      />

      <Dialog
        header="¿Desea reprogramar el mantenimiento?"
        visible={visibleModal}
        style={{ width: "30vw" }}
        onHide={() => setVisibleModal(false)}
      >
        <div className="form-row">
          <FieldDropDown
            name="motivoReprogramacion"
            label="Motivo de Reprogramación"
            colMd={12}
            source="general/Motivo reprogramacion"
            errors={errorsReprogramacion}
            scrollHeight={150}
            filter
            value={entity.motivoReprogramacion}
            onChange={actualizar}
          />
          <FieldTextArea
            name="ComentariosReprogramacion"
            label="Comentarios"
            colMd={12}
            rows={6}
            errors={errorsReprogramacion}
            value={entity.ComentariosReprogramacion}
            onChange={actualizar}
          />
        </div>
        <div className="">
          <Button
            label="Confirmar"
            className={"float-right"}
            type="button"
            onClick={guardarReprogramacion}
          />
        </div>
      </Dialog>

      <div className="form-container ot-detalle">
        <Dialog
          header="Registrar taller externo"
          visible={modalOtroTallerVisible}
          style={{ width: "450px" }}
          modal
          closable
          onHide={cerrarModalOtroTaller}
          footer={
            <div>
              <Button
                type="button"
                label="Cancelar"
                className="p-button-text"
                onClick={cerrarModalOtroTaller}
              />

              <Button
                type="button"
                label="Guardar"
                onClick={guardarNombreOtroTaller}
              />
            </div>
          }
        >
          <FieldTextBox
            name="nombreTallerTemporal"
            label="Nombre del proveedor"
            colMd={12}
            required
            value={nombreTallerTemporal}
            onChange={(value) => setNombreTallerTemporal(value ?? "")}
          />
        </Dialog>
        <div className="form-filtro form-row">
          {ordenTrabajoId > 0 && (
            <div className="form-group col-md-0 d-flex align-items-end">
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                  color: "#000",
                  lineHeight: "44px",
                }}
              >
                OT-{entity.codigo}
              </div>
            </div>
          )}

          <FieldDropDown
            name="tipoServicio"
            label="Tipo de Servicio"
            colMd={2}
            source="tipoServicio"
            disabled={ordenTrabajoId > 0}
            errors={errors}
            value={entity.tipoServicio}
            requiredIoDocumentText
            onChange={actualizar}
          />
          <FieldDropDown
            label={"Empresa"}
            name={"empresaId"}
            value={entity?.empresaId}
            colMd={2}
            onChange={actualizar}
            source={"empresas"}
          />

          {entity.tipoServicio?.id ===
            constantes.tiposServicio.MantenimientoPreventivo && (
            <>
              <FieldDropDown
                name="mantenimiento"
                label="Mantenimiento"
                colMd={2}
                required
                source="tiposMantenimiento"
                disabled={ordenTrabajoId > 0}
                errors={errors}
                value={entity.mantenimiento}
                onChange={actualizar}
              />
            </>
          )}

          <FieldAutoComplete
            required
            name="unidad"
            label="No Económico"
            colMd={2}
            errors={errors}
            source="unidades"
            params={{ todasLasEmpresas: true }}
            freeText={true}
            disabled={ordenTrabajoId > 0}
            value={entity.unidad}
            onChange={actualizar}
          />

          <FieldTextBox
            name="tipoUnidad"
            disabled={true}
            errors={errors}
            value={entity.unidad?.tipoUnidad}
            label="Tipo Unidad"
            colMd={2}
          />

          <FieldTextBox
            name="nombreSolicitante"
            disabled={true}
            errors={errors}
            value={
              entity.nombreSolicitante == null
                ? solicitante
                : entity.nombreSolicitante
            }
            label="Nombre Solicitante"
            colMd={3}
            onChange={actualizar}
          />

          <FieldCheckBox
            name="esExterno"
            label="Externo"
            value={entity.esExterno}
            onChange={actualizar}
            className="py-1"
            colMd={2}
          />
          {esRescate && (
            <FieldDropDown
              name="responsableRescate"
              label="Quién atendió el rescate"
              colMd={3}
              source="mecanicos"
              params={{ todasLasEmpresas: true }}
              filter={true}
              required
              disabled={soloLectura}
              errors={errors}
              value={entity.responsableRescate}
              onChange={actualizar}
            />
          )}
          <FieldAutoComplete
            name="operador"
            label="Operador"
            colMd={3}
            errors={errors}
            source="operadores"
            params={{ todasLasEmpresas: true }}
            value={entity.operador}
            onChange={actualizar}
          />

          <FieldTextBox
            name="jefeInmediatoNombre"
            label="Jefe inmediato"
            colMd={3}
            disabled
            errors={errors}
            value={entity.jefeInmediatoNombre ?? ""}
          />

          <FieldTextBox
            name="unidadDeNegocio"
            label="Unidad de negocio"
            colMd={2}
            disabled
            errors={errors}
            value={entity.unidadDeNegocio ?? ""}
          />

          <div className="field-iconos btn-group">
            <ButtonIcon
              title="Regresar"
              onClick={back}
              iconName={"BiArrowBack"}
            />
            {!soloLectura && (
              <>
                {ordenTrabajoId > 0 &&
                  entity.estatus !==
                    constantes.estatusOrdenesTrabajo.MttoRealizado &&
                  entity.estatus !==
                    constantes.estatusOrdenesTrabajo.cancelado && (
                    <ButtonIcon
                      title="Cancelar"
                      onClick={openModalCancelar}
                      iconName={"FcCancel"}
                    />
                  )}
                {entity.estatus !==
                  constantes.estatusOrdenesTrabajo.MttoRealizado &&
                  entity.estatus !==
                    constantes.estatusOrdenesTrabajo.cancelado && (
                    <>
                      <ButtonIcon
                        title="Guardar"
                        iconName={"AiOutlineSave"}
                        onClick={guardar}
                      />
                    </>
                  )}
                {entity.estatus !==
                  constantes.estatusOrdenesTrabajo.MttoRealizado &&
                  entity.estatus !==
                    constantes.estatusOrdenesTrabajo.cancelado &&
                  entity.estatus !==
                    constantes.estatusOrdenesTrabajo.pteProgramar && (
                    <>
                      <ButtonIcon
                        title="Terminar Orden"
                        iconName={"FaCheckCircle"}
                        onClick={terminar}
                      />
                    </>
                  )}

                {permisoReabriOrden &&
                  entity.estatus ===
                    constantes.estatusOrdenesTrabajoNombre.MttoRealizado && (
                    <>
                      <ButtonIcon
                        title="Reabrir Orden"
                        iconName={"FaReceipt"}
                        onClick={reabrir}
                      />
                    </>
                  )}
                {ordenTrabajoId > 0 &&
                  !checkListVisible &&
                  entity.estatus !==
                    constantes.estatusOrdenesTrabajo.cancelado && (
                    <ButtonIcon
                      title="Impresion"
                      className={"secondary-icon"}
                      iconName={"BiPrinter"}
                      onClick={() =>
                        printJS(
                          `${process.env.REACT_APP_API_URL}/taller/mantenimiento/OrdenesTrabajo/${ordenTrabajoId}/pdf/${solicitante}`,
                        )
                      }
                    />
                  )}
              </>
            )}

            {ordenTrabajoId > 0 && checkListVisible && (
              <div>
                {/* <CheckList ref={componentRef} /> */}
                <ButtonIcon
                  title="Impresion"
                  className={"secondary-icon"}
                  iconName={"BiPrinter"}
                  onClick={() => PrintPdf()}
                />
              </div>
            )}

            {!soloLectura && (
              <>
                {(entity.estatus ===
                  constantes.estatusOrdenesTrabajo.programada ||
                  entity.estatus ===
                    constantes.estatusOrdenesTrabajo.reprogramada) && (
                  <ButtonIcon
                    title="Entrada a Taller"
                    className={"action"}
                    iconName={"FaWrench"}
                    onClick={entradaTaller}
                  />
                )}

                {entity.estatus ===
                  constantes.estatusOrdenesTrabajo.entradaTaller &&
                  !checkListVisible &&
                  mostrarAreaCheckList && (
                    <ButtonIcon
                      title="Checklist"
                      onClick={obtenerCheckList}
                      className={"action"}
                      iconName={"BiCheckCircle"}
                    />
                  )}

                {(entity.estatus ===
                  constantes.estatusOrdenesTrabajo.programada ||
                  entity.estatus ===
                    constantes.estatusOrdenesTrabajo.reprogramada) &&
                  !checkListVisible && (
                    <>
                      {/* {mostrarAreaCheckList &&} */}

                      {((entity.tipoServicio?.id ===
                        constantes.tiposServicio.MantenimientoCorrectivo &&
                        (entity.unidad?.tipoUnidadId ===
                          constantes.tiposUnidad.Utilitario ||
                          entity.unidad?.tipoUnidadId ===
                            constantes.tiposUnidad.Pipa)) ||
                        (entity.unidad?.tipoUnidadId ===
                          constantesCatalogos.tiposUnidad.Utilitario &&
                          entity.tipoServicio?.id ===
                            constantes.tiposServicio
                              .MantenimientoPreventivo)) && (
                        <ButtonIcon
                          title="Confirmar Orden"
                          onClick={confirmarOrden}
                          className={"action"}
                          iconName={"IoDocumentText"}
                        />
                      )}
                    </>
                  )}

                {entity.estatus ===
                  constantes.estatusOrdenesTrabajo.entradaTaller &&
                  checkListVisible && (
                    <ButtonIcon
                      title=""
                      onClick={guardarCheck}
                      className={"action"}
                      iconName={"IoDocumentText"}
                    />
                  )}
              </>
            )}
          </div>
        </div>

        <br />
        {!checkListVisible && (
          <div
            className={`section-container ${
              submitted === true ? "submitted" : ""
            }`}
          >
            <div className="flex-col-6">
              <div className="form-row">
                <div className={`form-group col-md-11 col-sm-11`}>
                  <h5>Programación</h5>
                </div>
              </div>

              <div className="form-row">
                <div className={`form-group col-md-8 col-sm-8 margintop`}>
                  <div className="form-row">
                    <div className={`form-group col-md-4 col-sm-4`}>
                      <label>* Fecha y hora de ingreso programado</label>
                    </div>

                    <div className={`form-group col-md-8 col-sm-8`}>
                      <FieldCalendar
                        name="fechaEntrada"
                        label=""
                        required={true}
                        className="small"
                        showButtonBar={false}
                        value={entity.fechaEntrada}
                        colMd={6}
                        errors={errors}
                        showTime={true}
                        onChange={actualizar}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className={`form-group col-md-8 col-sm-8`}>
                  <div className="form-row">
                    <div className={`form-group col-md-4 col-sm-4`}>
                      <label>* Fecha y hora de liberación estimada</label>
                    </div>

                    <div className={`form-group col-md-8 col-sm-8`}>
                      <FieldCalendar
                        name="fechaSalida"
                        className="small"
                        required
                        showButtonBar={false}
                        value={entity.fechaSalida}
                        colMd={6}
                        errors={errors}
                        showTime={true}
                        onChange={actualizar}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className={`form-group col-md-8 col-sm-8 margintop`}>
                  <div className="form-row">
                    <div className={`form-group col-md-11 col-sm-11`}>
                      <h5>En taller</h5>
                    </div>
                    <div className={`form-group col-md-4 col-sm-4`}>
                      <label>Fecha y hora de ingreso a taller</label>
                    </div>

                    <div className={`form-group col-md-8 col-sm-8`}>
                      <FieldCalendar
                        name="fechaEnTaller"
                        label=""
                        className="small"
                        showButtonBar={false}
                        value={entity.fechaEnTaller}
                        colMd={6}
                        showTime={true}
                        onChange={actualizar}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className={`form-group col-md-8 col-sm-8`}>
                  <div className="form-row">
                    <div className={`form-group col-md-4 col-sm-4`}>
                      <label>Fecha y hora liberación de taller</label>
                    </div>

                    <div className={`form-group col-md-8 col-sm-8`}>
                      <FieldCalendar
                        name="fechaCompromiso"
                        label=""
                        className="small"
                        showButtonBar={false}
                        value={entity.fechaCompromiso}
                        colMd={6}
                        showTime={true}
                        onChange={actualizar}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {entity.esExterno && (
                <div className="form-row">
                  <FieldInputNumber
                    name="costoServicio"
                    label="Costo Servicio"
                    colMd={6}
                    fractionDigits={2}
                    value={entity.costoServicio}
                    onChange={actualizar}
                  />
                </div>
              )}
              <div className="form-row">
                <FieldInputNumber
                  name="costoGeneral"
                  label="Costo general"
                  colMd={6}
                  fractionDigits={2}
                  value={entity.costoGeneral}
                  errors={errors}
                  onChange={actualizar}
                />
              </div>
              {/* {!entity.esExterno && (
                <div className="form-row">
                  <div className="col-6">
                    <table className="table table-borderless">
                      <thead className="thead-light">
                        <tr>
                          <th style={{ width: "25%" }}>Mecánico</th>

                          <th
                            className={"ag-grid header-icons"}
                            style={{ width: "10%" }}
                          >
                            {!soloLectura && (
                              <ButtonIcon
                                title={"Agregar Mecanico"}
                                iconName={"SiAddthis"}
                                className="grid-action"
                                onClick={agregarMecanico}
                              />
                            )}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {entity?.mecanicos?.map((item, index) => {
                          return (
                            <tr style={{ position: "relative" }} key={index}>
                              <td style={{ display: "flex" }} className="input">
                                  <FieldDropDown
                                    name="mecanico"
                                    label="Mecánico"
                                    filter={true}
                                    colMd={12}
                                    source="mecanicos"
                                              params={{ todasLasEmpresas: true }}
                                    errors={errors}
                                    value={item?.id}
                                    onChange={(value, pName) =>
                                      actualizarMecanicos(value, pName, index)
                                    }
                                  />
                              </td>

                              <td>
                                {!soloLectura && (
                                  <ButtonIcon
                                    title={"Eliminar"}
                                    iconName={"RiDeleteBinLine"}
                                    onClick={() => eliminarMecanico(index)}
                                  />
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              )} */}
              {entity.esExterno && (
                <div className="form-row">
                  <div className="col-12">
                    <div style={{ overflow: "visible" }}>
                      {" "}
                      <table className="table table-borderless mb-0">
                        <thead className="thead-light">
                          <tr>
                            <th style={{ width: "42%" }}>Taller externo</th>

                            <th style={{ width: "48%" }}>Proveedor</th>

                            <th
                              className="ag-grid header-icons"
                              style={{ width: "10%" }}
                            >
                              {!soloLectura && (
                                <div
                                  style={{
                                    display: "inline-flex",
                                    transform: "scale(1.35)",
                                    transformOrigin: "center",
                                  }}
                                >
                                  <ButtonIcon
                                    title="Agregar taller externo"
                                    iconName="SiAddthis"
                                    className="grid-action"
                                    onClick={agregarExterno}
                                  />
                                </div>
                              )}
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {entity?.tallerExterno?.map((item, index) => {
                            const esOtros = esTallerOtros(item);
                            const proveedor =
                              item.nombreProveedorOtro?.trim() ?? "";

                            return (
                              <tr key={index}>
                                <td className="input align-middle">
                                  <FieldDropDown
                                    name="tallerExterno"
                                    colMd={12}
                                    source="externos"
                                    errors={errors?.[`tallerExterno[${index}]`]}
                                    value={item.id}
                                    onChange={(value, propertyName) =>
                                      actualizarExterno(
                                        value,
                                        propertyName,
                                        index,
                                      )
                                    }
                                  />
                                </td>

                                <td className="align-middle">
                                  <div className="d-flex align-items-center">
                                    <div
                                      className={`form-control bg-light text-truncate ${
                                        proveedor ? "" : "text-muted"
                                      }`}
                                      title={
                                        esOtros
                                          ? proveedor || "Pendiente de captura"
                                          : "No aplica"
                                      }
                                    >
                                      {esOtros
                                        ? proveedor || "Pendiente de captura"
                                        : "No aplica"}
                                    </div>

                                    {esOtros && !soloLectura && (
                                      <Button
                                        type="button"
                                        label={
                                          proveedor ? "Editar" : "Capturar"
                                        }
                                        icon="pi pi-pencil"
                                        className="p-button-text p-button-sm ml-2"
                                        style={{ whiteSpace: "nowrap" }}
                                        onClick={() =>
                                          abrirModalOtroTaller(index)
                                        }
                                      />
                                    )}
                                  </div>
                                </td>

                                <td className="align-middle text-center">
                                  {!soloLectura && (
                                    <ButtonIcon
                                      title="Eliminar"
                                      iconName="RiDeleteBinLine"
                                      onClick={() => eliminarExterno(index)}
                                    />
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="flex-col-6">
              <h5>Datos Unidad</h5>
              <div className="form-row">
                <div className={`form-group col-md-12 col-sm-12`}>
                  <table className="table table-borderless tablemargin">
                    <thead>
                      <tr>
                        <th>PLACAS</th>
                        <th>MARCA</th>
                        <th>MODELO</th>
                        <th>AÑO</th>
                        <th>ODOMETRO ACTUAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{unidadInformacion?.placas}</td>
                        <td>{unidadInformacion?.marca}</td>
                        <td>{unidadInformacion?.modelo}</td>
                        <td>{unidadInformacion?.anio}</td>
                        <td>
                          <FieldInputNumber
                            label=""
                            className="small"
                            name="odometro"
                            showButtonBar={false}
                            disabled={
                              entity.tipoServicio?.id !==
                              constantes.tiposServicio.MantenimientoPreventivo
                            }
                            value={entity.odometro}
                            colMd={6}
                            errors={errors}
                            onChange={actualizar}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="form-row">
                <div className={`form-group col-md-10 col-sm-10`}>
                  <table className="table table-borderless tablemargin">
                    <thead>
                      <tr>
                        <th>ULTIMO MANTENIMIENTO</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{unidadInformacion.ultimoMantenimiento}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div>
                  <strong>Formato Inspeccion de Unidades</strong>
                  <InputFile
                    name="evidencia"
                    value={entity.evidencia}
                    onChange={actualizar}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <br />
        {mostrarInfo && (
          <>
            {ordenTrabajoId > 0 && entity.fallas.length > 0 && (
              <>
                <div
                  className={`section-container ${
                    submitted === true ? "submitted" : ""
                  }`}
                >
                  <div className="flex-col-6">
                    <h5>Descripcion de Fallas</h5>
                    {entity.fallas?.map((item, index) => {
                      return (
                        <div key={index} style={{ marginTop: 8 }}>
                          <FieldTextBox
                            name="descripcion"
                            value={index + 1 + ".- " + item.descripcion}
                            disabled={entity.id > 0}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="flex-col-6">
                    <h5>Comentarios</h5>
                    <FieldTextArea
                      name="comentarios"
                      errors={errors}
                      required
                      onChange={actualizar}
                      value={entity.comentarios}
                      rows={fallas}
                    />
                  </div>
                </div>
              </>
            )}

            <br />

            <div
              className={`section-container ${
                errorServicios === true ? "danger" : ""
              }`}
            >
              <div className="flex-col-12 minheight">
                <h5>Solicitudes de Servicio</h5>
                <div className="form-row">
                  <table className="table">
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: "5%" }}></th>
                        <th scope="col" style={{ width: "10%" }}>
                          Solicitud Servicio
                        </th>
                        <th scope="col" style={{ width: "20%" }}>
                          Fecha solicitante
                        </th>
                        <th scope="col" style={{ width: "20%" }}>
                          Nombre solicitante
                        </th>
                        <th scope="col" style={{ width: "20%" }}>
                          Descripcion
                        </th>
                        <th scope="col" style={{ width: "10%" }}>
                          Ver
                        </th>

                        {/* <th style={{ width: "10%" }}>
                        <ButtonIcon
                          title="Agregar Servicio"
                          iconName="SiAddthis"
                          onClick={() => setmostrarSolicitudServicio(true)}
                        />
                      </th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {!Array.isArray(entity?.solicitudesServicio) ||
                      entity.solicitudesServicio.length === 0 ? (
                        <tr></tr>
                      ) : (
                        entity.solicitudesServicio.map((v, index) => (
                          <tr key={v.id || index}>
                            <td>
                              <FieldCheckBox
                                name="seleccionado"
                                value={v.seleccionado}
                                onChange={(value) =>
                                  actualizarSeleccion(index, value)
                                }
                              />
                            </td>
                            <td>{v.codigo}</td>
                            <td>
                              {moment(v.fechaSolicitud).format(
                                "YYYY-MM-DD HH:mm:00",
                              )}
                            </td>
                            <td>{v.solicitante.nombre}</td>
                            <td>{v.descripcion}</td>
                            <td className="center">
                              <button
                                type="button"
                                className="ot-link-ver"
                                onClick={() => abrirDetalleSolicitud(v.id)}
                              >
                                VER
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div id="diagnostico" className="flex-col-12 danger  minheight">
                <h5>Diagnóstico</h5>
                <div className="form-row">
                  <div className="table-responsive w-100">
                    <table className="table">
                      <thead className="thead-light">
                        <tr>
                          <th style={{ width: "15%" }}>Tipo de falla</th>
                          <th style={{ width: "15%" }}>Causa de falla</th>
                          <th style={{ width: "15%" }}>¿Por qué?</th>
                          <th style={{ width: "15%" }}>Riesgo</th>
                          <th style={{ width: "5%" }} className="text-center">
                            <ButtonIcon
                              title={"Agregar Diagnostico"}
                              iconName={"SiAddthis"}
                              onClick={() =>
                                agregarALista(
                                  entity.diagnostico ?? [],
                                  "diagnostico",
                                )
                              }
                            />
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {entity.diagnostico?.map((item, index) => (
                          <tr key={index}>
                            {/* TIPO FALLA */}
                            <td className="input">
                              <FieldDropDown
                                name="tipoFallaId"
                                value={item.tipoFallaId}
                                source="tipoFalla"
                                onChange={(value) =>
                                  actualizarLista(
                                    entity.diagnostico,
                                    index,
                                    value,
                                    "tipoFallaId",
                                    "diagnostico",
                                  )
                                }
                              />
                            </td>

                            {/* CAUSA */}
                            <td className="input">
                              <FieldDropDown
                                name="causaFallaId"
                                value={item.causaFallaId}
                                source="causaFalla"
                                onChange={(value) =>
                                  actualizarLista(
                                    entity.diagnostico,
                                    index,
                                    value,
                                    "causaFallaId",
                                    "diagnostico",
                                  )
                                }
                              />
                            </td>

                            {/* PORQUE */}
                            <td className="input">
                              <FieldDropDown
                                name="porqueId"
                                value={item.porqueId}
                                source="responsableDiagnostico"
                                onChange={(value) =>
                                  actualizarLista(
                                    entity.diagnostico,
                                    index,
                                    value,
                                    "porqueId",
                                    "diagnostico",
                                  )
                                }
                              />
                            </td>
                            {/* RIESGO */}
                            <td className="input">
                              <FieldDropDown
                                name="riesgoId"
                                value={item.riesgoId}
                                source="riesgoDiagnostico"
                                onChange={(value) =>
                                  actualizarLista(
                                    entity.diagnostico,
                                    index,
                                    value,
                                    "riesgoId",
                                    "diagnostico",
                                  )
                                }
                              />
                            </td>

                            {/* ELIMINAR */}
                            <td className="text-center">
                              <ButtonIcon
                                title={"Eliminar"}
                                iconName={"RiDeleteBinLine"}
                                onClick={() =>
                                  eliminarDeLista(
                                    entity.diagnostico,
                                    index,
                                    "diagnostico",
                                  )
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className={"flex-col-12"}>
                <div
                  className={`section-container ${
                    submitted === true ? "submitted" : ""
                  }`}
                >
                  <div className="flex-col-12">
                    <h5>Diagnóstico Final</h5>
                    <FieldTextArea
                      onChange={actualizar}
                      required
                      errors={errors}
                      name="diagnosticoFinal"
                      value={entity.diagnosticoFinal}
                      rows={fallas}
                    />
                  </div>
                </div>
              </div>
              <div id="servicios" className="flex-col-12 danger  minheight">
                <h5>Servicios a Realizar</h5>

                <div className="">
                  <table className="table main-edit-table" align="right">
                    <thead className="thead-light">
                      <tr>
                        <th scope="col" style={{ width: "10%" }}>
                          ACTIVIDAD
                        </th>
                        <th scope="col" style={{ width: "10%" }}></th>
                        <th scope="col" style={{ width: "50%" }}></th>
                        <th scope="col" style={{ width: "30%" }}></th>
                        <th style={{ width: "4%" }}>
                          <ButtonIcon
                            title={"Agregar Servicio"}
                            iconName={"SiAddthis"}
                            onClick={() =>
                              agregarALista(entity.servicios, "servicios")
                            }
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {entity.servicios?.map((item, index) => {
                        return (
                          <tr
                            key={
                              item.rowId ?? item.id ?? item.servicioId ?? index
                            }
                          >
                            <td className="input">
                              <div className="p-field-radiobutton main-item-container">
                                <RadioButton
                                  name="existente"
                                  value={true}
                                  onChange={(e, name) =>
                                    actualizarLista(
                                      entity.servicios,
                                      index,
                                      e.value,
                                      "existente",
                                      "servicios",
                                    )
                                  }
                                  checked={item.existente === true}
                                />
                                <label>Existente</label>
                              </div>
                            </td>
                            <td className="input">
                              <div className="p-field-radiobutton main-item-container">
                                <RadioButton
                                  name="existente"
                                  value={false}
                                  onChange={(e, name) =>
                                    actualizarLista(
                                      entity.servicios,
                                      index,
                                      e.value,
                                      "existente",
                                      "servicios",
                                    )
                                  }
                                  checked={item.existente === false}
                                />
                                <label>Nuevo</label>
                              </div>
                            </td>
                            <td className="input">
                              {item.existente === true && (
                                <>
                                  <FieldAutoComplete
                                    name="actividadServicio"
                                    errors={errors?.[`servicios[${index}]`]}
                                    source="ActividadesServiciosSearch"
                                    freeText={true}
                                    value={item.actividadServicio}
                                    onChange={(value) =>
                                      actualizarLista(
                                        entity.servicios,
                                        index,
                                        value,
                                        "actividadServicio",
                                        "servicios",
                                      )
                                    }
                                  />
                                </>
                              )}

                              {item.existente === false && (
                                <>
                                  <FieldTextBox
                                    errors={errors?.[`servicios[${index}]`]}
                                    name="descripcion"
                                    upperCase={true}
                                    onChange={(value, pName) =>
                                      actualizarLista(
                                        entity.servicios,
                                        index,
                                        value,
                                        "descripcion",
                                        "servicios",
                                      )
                                    }
                                    value={item.descripcion}
                                  />
                                </>
                              )}
                            </td>
                            {!entity.esExterno && (
                              <td>
                                <FieldDropDown
                                  name="mecanico"
                                  key={
                                      esMantenimientoPreventivo
                                        ? `mecanico-${item.rowId ?? index}-${item.mecanicoId ?? 0}`
                                        : undefined
                                    }
                                  filter={true}
                                  colMd={12}
                                  source="mecanicos"
                                  params={{ todasLasEmpresas: true }}
                                  errors={errors?.[`servicios[${index}]`]}
                                  value={item?.mecanicoId}
                                  onChange={(value, pName) =>
                                    actualizarMecanicoservicios(
                                      value,
                                      pName,
                                      index,
                                    )
                                  }
                                />
                                
                              </td>
                            )}
                            <td className="input">
                              <ButtonIcon
                                title={"Eliminar"}
                                onClick={() =>
                                  eliminarDeLista(
                                    entity.servicios,
                                    index,
                                    "servicios",
                                  )
                                }
                                iconName={"RiDeleteBinLine"}
                              />
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="flex-col-6 minheight">
                <h5>Refacciones</h5>
                <div className="form-row">
                  <table className="table">
                    <thead className="thead-light">
                      <tr>
                        <th
                          scope="col"
                          className="center"
                          style={{ width: "10%" }}
                        >
                          CODIGO
                        </th>
                        <th scope="col" style={{ width: "50%" }}>
                          DESCRIPCION
                        </th>
                        <th scope="col" style={{ width: "5%" }}>
                          UNIDAD
                        </th>
                        <th
                          scope="col"
                          className="center"
                          style={{ width: "15%" }}
                        >
                          CANTIDAD
                        </th>
                        <th
                          scope="col"
                          className="center"
                          style={{ width: "15%" }}
                        >
                          PRECIO
                        </th>
                        <th className={"input"} style={{ width: "10%" }}>
                          <ButtonIcon
                            title={"Agregar Refacciones"}
                            iconName={"FcEmptyBattery"}
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {entity.refacciones?.map((item, index) => {
                        const isVisible =
                          item.estatusSAAS === "Negativo" ? true : false;
                        return isVisible ? (
                          <tr key={index}>
                            <td className="input center">
                              <label>
                                {item.existente === true && item.codigo}

                                {item.existente === true &&
                                  item.refaccion?.codigo}
                              </label>
                            </td>
                            <td className="input center">
                              {item.existente === true && (
                                <>
                                  <FieldAutoComplete
                                    name="refaccion"
                                    errors={errors?.[`refacciones[${index}]`]}
                                    source="refacciones"
                                    freeText={true}
                                    value={item.refaccion}
                                    disabled={true}
                                    onChange={(value) =>
                                      actualizarLista(
                                        entity.refacciones,
                                        index,
                                        value,
                                        "refaccion",
                                        "refacciones",
                                      )
                                    }
                                  />
                                </>
                              )}

                              {item.existente === false && (
                                <>
                                  <FieldTextBox
                                    name="nombre"
                                    upperCase={true}
                                    errors={errors?.[`refacciones[${index}]`]}
                                    disabled={true}
                                    onChange={(value) =>
                                      actualizarLista(
                                        entity.refacciones,
                                        index,
                                        value,
                                        "nombre",
                                        "refacciones",
                                      )
                                    }
                                    value={item.nombre}
                                  />
                                </>
                              )}
                            </td>
                            <td className="input center">
                              <label>
                                {item.existente === true &&
                                  item.unidadDeMedida?.nombre}
                                {item.existente === true &&
                                  item.refaccion?.unidadDeMedida?.nombre}
                              </label>

                              {item.existente === false && (
                                <FieldDropDown
                                  name="unidadDeMedida"
                                  source="unidadesDeMedida"
                                  required
                                  errors={errors?.[`refacciones[${index}]`]}
                                  value={item.unidadDeMedida}
                                  onChange={(value) =>
                                    actualizarLista(
                                      entity.refacciones,
                                      index,
                                      value,
                                      "unidadDeMedida",
                                      "refacciones",
                                    )
                                  }
                                />
                              )}
                            </td>
                            <td className="input center">
                              <label>
                                {item.existente === true && item.cantidad}
                              </label>
                            </td>
                            <td className="input center">
                              <label>
                                {item.existente === true &&
                                  item.refaccion?.costo}
                              </label>
                            </td>
                            <td className="input"></td>
                          </tr>
                        ) : null;
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="flex-col-6 minheight">
                <h5>Requisiciones</h5>
                <div className="form-row">
                  <table className="table">
                    <thead className="thead-light">
                      <tr>
                        <th
                          scope="col"
                          className="center"
                          style={{ width: "10%" }}
                        >
                          No Requisición
                        </th>
                        <th
                          scope="col"
                          className="center"
                          style={{ width: "10%" }}
                        >
                          Fecha
                        </th>
                        <th scope="col" style={{ width: "50%" }}>
                          Comentarios
                        </th>
                        <th scope="col" style={{ width: "5%" }}>
                          Almacén
                        </th>
                        <th
                          scope="col"
                          className="center"
                          style={{ width: "15%" }}
                        >
                          Cantidad
                        </th>
                        <th scope="col" style={{ width: "10%" }}>
                          Ver
                        </th>
                        <th style={{ width: "10%" }}>
                          <ButtonIcon
                            title="Agregar Requisicion"
                            iconName="SiAddthis"
                            onClick={agregarRequisicion}
                          />
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {!Array.isArray(entity?.requisiciones) ||
                      entity.requisiciones.length === 0 ? (
                        <tr>
                          <td colSpan={6}>No hay requisiciones asignadas.</td>
                        </tr>
                      ) : (
                        entity.requisiciones.map((req, index) => (
                          <tr key={req.id || index}>
                            <td>{req.id}</td>
                            <td>{req.fecha}</td>
                            <td>{req.comentarios}</td>
                            <td>{req.almacen}</td>
                            <td className="center">{req.cantidad}</td>
                            <td className="center">
                              <button
                                type="button"
                                className="ot-link-ver"
                                onClick={() =>
                                  abrirDetalleRequisiciones(req.id)
                                }
                              >
                                VER
                              </button>
                            </td>
                            <td></td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className={"flex-col-6"}>
                <h5>Historial</h5>
                <div className="ot-log-wrapper">
                  <LogOrdenTrabajo data={entity?.logs ?? entity?.Logs ?? []} />
                </div>
              </div>
              {(ordenTrabajoId === 0 || entity.fallas.length === 0) && (
                <>
                  <div className={"flex-col-6"}>
                    <div
                      className={`section-container ${
                        submitted === true ? "submitted" : ""
                      }`}
                    >
                      <div className="flex-col-12">
                        <h5>Comentarios</h5>
                        <FieldTextArea
                          onChange={actualizar}
                          required
                          errors={errors}
                          name="comentarios"
                          value={entity.comentarios}
                          rows={fallas}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        )}

        <br />
        {checkListVisible && (
          <CheckList
            guardarInformacion={guardarCheckList}
            cancelarGuardado={cancelarGuardado}
            ordenTrabajoId={ordenTrabajoId}
            tipoUnidadId={entity.unidad?.tipoUnidadId}
          />
        )}

        {mostrarRequisicion && (
          <RequisicionDetalle
            requisicionId={requisicionId}
            onCancel={() => setMostrarRequisicion(false)}
            onSaved={onSaveRequisicion}
            puedeEditar={requisicionId > 0 ? false : true}
            empleado={empleado}
            soloLectura={requisicionId > 0 ? true : false}
            defaultValues={{
              departamento: constantes.departamento.Mantenimiento,
              unidadId: entity.unidad,
              estatusId: constantes.estatusRequisiciones.Solicitada,
            }}
          />
        )}
        {mostrarSolicitudServicio && (
          <Dialog
            header="Solicitud Servicio"
            visible={mostrarSolicitudServicio}
            modal
            appendTo={document.body}
            className="dlg-solicitud-servicio"
            style={{ width: "60vw" }}
            contentStyle={{
              maxHeight: "80vh",
              overflowY: "auto",
              overflowX: "hidden",
            }}
            onHide={cerrarDetalleSolicitud}
          >
            <DetalleSolicitudServicio
              onUpdateStatus={actualizar}
              onSave={onSaveSolicitud}
              solicitudServicioId={solicitudServicioId}
              ordenTrabajoId={ordenTrabajoId}
              closeSolicitud={cerrarDetalleSolicitud}
              soloLectura={modoSoloVerSolicitud ? true : soloLectura}
              hideFooter={modoSoloVerSolicitud}
            />
          </Dialog>
        )}

        {/* {mostrarSolicitudServicio && (
          <Dialog
            header="Solicitud Servicio"
            visible={mostrarSolicitudServicio}
            style={{ width: '40vw' }}
            modal
            onHide={() => setmostrarSolicitudServicio(false)}
          >
             <DetalleSolicitudServicio
              onUpdateStatus={actualizar}
              onSave={onSaveSolicitud}
              solicitudServicioId={0}  
              ordenTrabajoId={ordenTrabajoId}
              closeSolicitud={() => setmostrarSolicitudServicio(false)}
              soloLectura={false}         
        />
          </Dialog>
        )}  */}
        <div style={{ display: "none" }}>
          <div ref={componentRef}>
            <ComponentToPrint
              numeroOrdenTrabajo={entity?.numeroOrdenTrabajo}
              numeroEconomico={entity?.numeroEconomico}
              ordenTrabajoId={ordenTrabajoId}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DetalleOrdenTrabajo;
